<div class="colored-text" [style.backgroundColor]="bgColor">
  <div [innerHTML]="text | keepHtml | multiLine | twemoji"></div>
</div>
